const BASE = "/post";

const CREATE_POST = `${BASE}/create-post`;
const UPDATE_POST = `${BASE}/update-post/{POST_ID}`;
const GET_POSTS = `${BASE}/get-posts`;
const GET_POST_DETAIL = `${BASE}/get-detail-post/{POST_ID}`;

const CHECK_MAIN_TOPIC_BY_CATE_POST = `${BASE}/check-main-topic`;
const CHECK_MAIN_TOPIC_OUTSTANDING = `${BASE}/check-main-topic-outstanding`;

/**POST REVISION */
const GET_LIST_POST_REVISION = `/post-revision/get-list-post-revision/{POST_ID}`;
const GET_DIFF_POST_REVISION = `/post-revision/get-diff-post-revision/{POST_REVISION_ID}`;

export const POST_ROUTE = {
  CREATE_POST,
  UPDATE_POST,
  GET_POSTS,
  GET_POST_DETAIL,
  CHECK_MAIN_TOPIC_BY_CATE_POST,
  CHECK_MAIN_TOPIC_OUTSTANDING,

  /**POST REVISION */
  GET_LIST_POST_REVISION,
  GET_DIFF_POST_REVISION,
};
